export function mapUserToDb(user) {
    return {
        username: user.username,
        username_lowercase: user.username.toLowerCase(),
        email: user.email.toLowerCase(),
        name: user.name,
        bio: user.bio,
        following: user.following,
        followers: user.followers,
    };
}
